export default "__VITE_ASSET__75802b80__"